import { useLayoutEffect } from 'react';

import { EPage } from '@types';

import { useLocalizationContext } from '../LocalizationProvider';

export const useRouteLocalization = (page: EPage) => {
  const { triggerTranslationLoad } = useLocalizationContext();

  //we are using layoutEffect since we want to force Localization provider to set correct state before first render
  useLayoutEffect(() => {
    triggerTranslationLoad(page);
  }, [page, triggerTranslationLoad]);
};
